import { render } from "./DisplayCurrencyRenderer.vue?vue&type=template&id=1ab0b514"
import script from "./DisplayCurrencyRenderer.vue?vue&type=script&lang=js"
export * from "./DisplayCurrencyRenderer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__